import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Tooltip} from '@material-ui/core';
import {Icon} from 'front-onceforall-core';

function FavoriteRelationshipView(props) {
  const icon = props.isFavorite ? 'star-full' : 'star-empty';

  return (
    <Tooltip
      title={<Translate value={`favoriteRelationship.${props.isFavorite ? 'remove' : 'add'}`}/>}
      placement="left"
    >
      <button
        className={props.isFavorite ? 'warning' : 'information'}
        onClick={props.onSwitch}
      >
        <Icon
          icon={props.loading ? 'loader' : icon}
          size={30}
        />
      </button>
    </Tooltip>
  );
}

FavoriteRelationshipView.propTypes = {
  loading: PropTypes.bool,
  isFavorite: PropTypes.bool,
  onSwitch: PropTypes.func.isRequired
};

export default FavoriteRelationshipView;
